var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-btn", {
    staticStyle: { width: "200px" },
    attrs: {
      color: _vm.SET_COLOR.primary,
      label: _vm.$t("label.ticketPdf"),
      icon: "fal fa-file-pdf"
    },
    on: {
      click: function($event) {
        _vm.$emit("start-download", _vm.ticket)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }